/**
 * © Copyright IBM Corp. 2020 All Rights Reserved
 *   Project name: JSONata
 *   This project is licensed under the MIT License, see LICENSE
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const jsonataMode = (monaco: any) => {
  // Register a new language
  monaco.languages.register({ id: 'jsonata' })

  // Register a tokens provider for the language
  monaco.languages.setMonarchTokensProvider('jsonata', {
    tokenizer: {
      root: [
        [/\/\*.*\*\//u, 'jsonata-comment'],
        [/'.*'/u, 'jsonata-string'],
        [/".*"/u, 'jsonata-string'],
        [/\$\w*/u, 'jsonata-variable'],
        [/\w+/u, 'jsonata-names'],
      ],
    },
  })

  const brackets = [
    { close: ')', open: '(' },
    { close: ']', open: '[' },
    { close: '}', open: '{' },
    { close: '"', open: '"' },
    { close: "'", open: "'" },
    { close: '`', open: '`' },
  ]
  monaco.languages.setLanguageConfiguration('jsonata', {
    autoClosingPairs: brackets,
    brackets: [
      ['(', ')'],
      ['[', ']'],
      ['{', '}'],
    ],
    insertSpaces: true,
    surroundingPairs: brackets,
    tabSize: 2,
  })

  // Define a new theme that contains only rules that match this language
  monaco.editor.defineTheme('jsonataTheme', {
    base: 'vs',
    colors: {
      'editor.background': '#fffffb',
    },
    inherit: true,
    rules: [
      { foreground: 'a00000', token: 'jsonata-string' },
      { foreground: '008000', token: 'jsonata-comment' },
      { foreground: 'ff4000', token: 'jsonata-variable' },
      { foreground: '0000c0', token: 'jsonata-names' },
    ],
  })

  // Define a new theme that contains only rules that match this language
  monaco.editor.defineTheme('jsonataThemeDisabled', {
    base: 'vs',
    colors: {
      'editor.background': '#f3f4f6',
      'input.foreground': '#9ca3af',
    },
    inherit: true,
    rules: [
      { foreground: '9ca3af', token: 'jsonata-string' },
      { foreground: '9ca3af', token: 'jsonata-comment' },
      { foreground: '9ca3af', token: 'jsonata-variable' },
      { foreground: '9ca3af', token: 'jsonata-names' },
    ],
  })
}

export default jsonataMode
